module.exports = __webpack_public_path__ + "img/custom-process.2e287b90.svg";